import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInBottomGif from '../../../assets/images/transitions/easeInBottom.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_OUT_BOTTOM = 'easeOutBottom';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeOutBottomPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_OUT_BOTTOM,

  // A human friendly name for the preset.
  humanName: 'Ease Out & Rotate From Bottom',

  // A preview of the transition.
  gif: easeInBottomGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        'position.bottom',
        'off.bottom'
      ],
      immediateRender: false
    },
    'transform.rotate': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        '0',
        '90'
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_OUT_BOTTOM,
    options: {},
  },
};

easeOutBottomPresetDetails.template.options = lodash.cloneDeep(easeOutBottomPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_OUT_BOTTOM;

// This defines the value of the presets object.
export default easeOutBottomPresetDetails;
